

<ng-container *ngIf="category.type ==='numeric-box'; else normalActivity">
  <div id="catDivId">
  <input matInput #reportInputValue type="text" [formControl]="categoryCtl" autocomplete="off" (keypress)="onlyNumbersWithDot($event)" [maxLength]="10">
</div>
</ng-container>

      <ng-template #normalActivity>
         {{category.value}}
      </ng-template>
